// extracted by mini-css-extract-plugin
module.exports = {"accordingTitle":"styles_accordingTitle__2QoI6","trainings_item":"styles_trainings_item__2ATdl"};